<template>
  <div class="column">
    <div class="column has-status-bar--left has-status-bar--draft">
      <div class="title is-6 is-uppercase">Vente Actée</div>
    </div>
    <div class="columns">
      <div class="column is-4 is-paddingless-right">
        <label class="label">Date Acte</label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-min-width-0">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <flat-pickr type="date" class="input is-border  is-padding-left-xxsmall is-padding-right-xxsmall"
                        ref="acteinput"
                        @input="updateSaleDate"
                        v-model="saleDate"
                        :disabled="!(isAdmin || isSectorManager)"
                        :config="dateConfig">
            </flat-pickr>
          </div>
          <div class="control" v-if="(isAdmin || isSectorManager)">
            <a class="button is-square is-grey is-inverted is-border is-min-width-0" @click="updateSaleDate(null)">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="column is-6" v-if="showCommentField && (isAdmin || isSectorManager)">
        <label for="" class="label">Commentaire</label>
        <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
          <div class="control">
            <wysiwyg-editor :model="adv.vente_actee.comment"
                            @change="val => editComment(val, adv.vente_actee, 'comment')"
                            placeholder="" :light='true'
                            :class="{'editr--hide-toolbar':!displayToolbar}"
                            class="editr--bottom-toolbar editr--height-small content has-bg-white" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column is-4">
        <div class="field">
        <label class="label">Fonds reçus</label>
    <h2 class="title"><strong>Vente Actée</strong></h2>
  </div>
  <div class="columns">
    <div class="column is-4">
      <label class="label">Date Acte</label>
      <div class="field has-addons">
        <div class="control is-expanded has-icons-right">
          <flat-pickr type="date" class="input is-radiusless"
                      @input="updateSaleDate"
                      v-model="saleDate"
                      :disabled="!isAdmin"
                      :config="dateConfig">
          </flat-pickr>
        </div>
        <div class="control" v-if="isAdmin">
          <a class="button is-grey is-inverted is-border-top is-border-bottom is-border-right is-min-width-0"
              @click="updateSaleDate(null)">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="column is-4" v-if="!showCommentField && isAdmin">
    <a @click="showCommentField = !showCommentField" class="has-text-reserve is-size-6">
        <span class="icon is-small">
        <i class="fal fa-sticky-note"></i></span>&nbsp;Ajouter un commentaire
    </a>
  </div>
  <div class="column is-4" v-if="showCommentField && isAdmin">
    <label for="" class="label">Commentaire</label>
    <textarea id="comment" name="comment" class="textarea" v-model="adv.vente_actee.comment"
              @input="commitAdv"
              placeholder="Rédiger ici votre commentaire">
    </textarea>
  </div>
  <div class="columns">
    <div class="column is-4">
      <div class="field">
        <label class="label">Fonds reçus</label>
        <flat-pickr type="date" class="input is-border"
                    @on-change="fondsRecusInput"
                    v-model="adv.vente_actee.fonds_recus"
                    :config="dateConfig">
        </flat-pickr>
      </div>
      <v-input id="fonds_recus" name="fonds_recus" @input="fondsRecusInput"
                :model="adv.vente_actee.fonds_recus"
                label="Fonds recus"
                v-validate="'numeric'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Fonds recus">
      </v-input>
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <v-input id="discount" name="discount" @input="discountInput"
                :model="adv.vente_actee.discount"
                label="Remise"
                v-validate="'numeric'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Remise">
      </v-input>
    </div>
    <div class="column is-4">
      <v-input id="discount" name="discount" @input="discountTypeInput"
                :model="adv.vente_actee.discount_type"
                label="Type de remise" :disabled="!adv.vente_actee.discount"
                v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Remise">
      </v-input>
    </div>
  </div>
    <div class="columns">
    <div class="column is-4">
      <div class="field">
        <label class="label">Date Actee</label>
        <flat-pickr type="date" class="input is-border"
                    @on-change="fondsRecusInput"
                    v-model="adv.vente_actee.fonds_recus"
                    :config="dateConfig">
        </flat-pickr>
      </div>
        <v-input id="fonds_recus" name="fonds_recus" @input="fondsRecusInput"
                :model="adv.vente_actee.fonds_recus"
                label="Fonds recus"
                v-validate="'numeric'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Fonds recus">
        </v-input>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <v-input id="discount" name="discount" @input="discountInput"
                :model="adv.vente_actee.discount"
                label="Remise"
                v-validate="'numeric'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Remise">
        </v-input>
      </div>
      <div class="column is-4">
        <v-input id="discount" name="discount" @input="discountTypeInput"
                :model="adv.vente_actee.discount_type"
                label="Type de remise" :disabled="!adv.vente_actee.discount"
                v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Remise">
        </v-input>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label">Date Actee</label>
          <flat-pickr type="date" class="input is-border"
                      @on-change="saleDateInput"
                      v-model="adv.sale_date"
                      :config="datetimeConfig">
          </flat-pickr>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Date signature prévue</label>
          <flat-pickr type="date" class="input is-border"
                      @on-change="signatureDateInput"
                      v-model="adv.vente_actee.date_signature"
                      :config="dateConfig">
          </flat-pickr>
        </div>
      </div> -->
  </div>
</template>

<script>
  import { isNil, debounce } from 'lodash'
  import { AdvMx } from '@/mixins'
  import moment from 'moment'

  export default {
    name: 'VenteActee',
    mixins: [AdvMx],
    data () {
      return {
        saleDate: null
      }
    },
    computed: {
      currentComment () {
        return this.adv.vente_actee.comment
      }
    },
    methods: {
      commitAdv: debounce(function (editedAdv, save = false) {
        let adv = Object.assign({}, this.adv)
        this.$emit('commit', adv, save)
      }, 500),
      updateSaleDate (value) {
        if (this.adv.sale_date && moment(value).format('DDMMYY') === moment(this.adv.sale_date).format('DDMMYY')) {
          return
        }
        if (isNil(value) || value.length === 0) {
          this.adv.sale_date = null
          this.saleDate = null
          this.adv.status = 'reserved'
          return this.commitAdv()
        }
        let date = value
        let saleDate = moment(date).utc()
        if (saleDate.isAfter(moment()) || saleDate.isSame(moment(), 'day')) {
          this.adv.status = 'sold'
        }
        this.adv.sale_date = saleDate.format('DD/MM/YYYY HH:mm')
        this.commitAdv()
      },
      fondsRecusInput (val) {
        this.adv.vente_actee.fonds_recus = val
        this.commitAdv()
      },
      discountInput (val) {
        this.adv.vente_actee.discount = val
        this.commitAdv()
      },
      discountTypeInput (val) {
        this.adv.vente_actee.discount_type = val
        this.commitAdv()
      }
    },
    created () {
      this.saleDate = this.adv.sale_date
    },
    mounted () {
      if ('acte' in this.$route.query && this.$refs.acteinput) {
        this.$refs.acteinput.$el.nextSibling.focus()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/VenteActee.vue